module.exports = __webpack_public_path__ + "static/media/Sort-A-Z-White.3bc2d9a5.svg";